<template>
  <Instance
    instance="company"
    instance-name="Company"
    :create="(d) => company.create(d)"
    :delete="(d) => company.remove(d)"
    :update="(d) => company.update(d)"
    :get="(d) => company.get(d)"
    :upsert="upsert"
    :columns="columns"
    :header="false"
    headerBg="#ffffff"
  />
</template>

// add position static for page header here

<script>
import { BIconPencil } from 'bootstrap-vue';

import Instance from '../../../CRUD/instance';
import api from '../../../../api';

export default {
  title: 'Company',
  components: { Instance },
  data() {
    return {
      company: api.company,
      upsert: [
        { value: 'name', name: 'Name', required: true },
        { value: 'cid', name: 'ID', required: true },
        { value: 'address', name: 'Address' },
        { value: 'corporation', name: 'Corporation', type: 'select', data: [], required: true },
      ],
    };
  },
  async created() {
    const corporation = await api.corporation.get();
    this.upsert.forEach((i) => {
      if (i.value === 'corporation') {
        i.data = corporation.map((c) => ({ value: c.id, text: `${c.name} (${c.address})` }));
      }
    });
  },
  methods: {
    columns({ editInstance }) {
      return [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center',
        },
        {
          field: 'cid',
          title: this.$translate('ID'),
          key: '11',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'name',
          title: this.$translate('Name'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'address',
          title: this.$translate('Address'),
          key: '4',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'corporation',
          title: this.$translate('Corporation'),
          key: '5',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.corporation ? `${row.corporation.name} (${row.corporation.address})` : '-';
          },
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="details-action" on-click={() => editInstance(row)}>
                  <BIconPencil />
                </div>
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
